// Libreria icone esecuzioni — sagome interne Medisistem (stile coerente, nessuna
// immagine esterna). Riferimento: immagine allegata (gambaletto, coscia, autoreggente,
// collant). Monocollant, bracciale e guanto ricostruiti da forme standard (da confermare).

const foot = <path d="M12 43.5 h5 l6.5 3 c1 .5 .7 2 -.4 2 H12 z" />;

const leg = (topY) => (
  <path
    d={`M17 ${topY} c-2.6 0 -4.6 1.9 -4.6 4.6 0 3 .4 5 1 7 .8 3 1 6 1 9 0 5 -.3 9 -1.2 13l-.5 2.9h6.6l-.5-2.9c-.9-4-1.2-8-1.2-13 0-3 .2-6 1-9 .6-2 1-4 1-7 0-2.7-2-4.6-4.6-4.6z`}
  />
);

const ICONS = {
  gambaletto: (
    <>
      {leg(24)}
      {foot}
    </>
  ),
  coscia: (
    <>
      {leg(12)}
      {foot}
    </>
  ),
  autoreggente: (
    <>
      {leg(12)}
      {foot}
      <rect x="11" y="12" width="12" height="3.4" rx="1.7" opacity="0.55" />
    </>
  ),
  monocollant: (
    <>
      <path d="M9 6 h16 v5 c0 2 -1 3 -2 4 H11 c-1 -1 -2 -2 -2 -4 z" />
      {leg(14)}
      {foot}
    </>
  ),
  collant: (
    <>
      <path d="M8 6 h20 v6 c0 2 -1 3 -2 4 H10 c-1 -1 -2 -2 -2 -4 z" />
      <path d="M13 15 c-2.4 0 -4 1.8 -4 4.4 0 4 .6 7 1.4 11 .7 3.4 1 6.6 1 10.5l-.4 3h5.6l-.3-3c0-3.9 .3-7.1 1-10.5H18z" />
      <path d="M27 15 c2.4 0 4 1.8 4 4.4 0 4 -.6 7 -1.4 11 -.7 3.4 -1 6.6 -1 10.5l.4 3h-5.6l.3-3c0-3.9 -.3-7.1 -1-10.5H22z" />
      <path d="M10 42 h4 l5 2.6 c1 .5 .7 2 -.4 2 H10 z" />
      <path d="M30 42 h-4 l-5 2.6 c-1 .5 -.7 2 .4 2 H30 z" />
    </>
  ),
  bracciale: (
    <>
      <path d="M15 5 c4 0 7 1 7 4 l1 30 c0 3 -2 5 -5 5 h-4 c-3 0 -5 -2 -5 -5 l1 -30 c0 -3 1 -4 4 -4z" />
    </>
  ),
  guanto: (
    <>
      <path d="M13 20 v-8 a1.6 1.6 0 0 1 3.2 0 v6 v-9 a1.6 1.6 0 0 1 3.2 0 v9 v-8 a1.6 1.6 0 0 1 3.2 0 v8 v-5 a1.6 1.6 0 0 1 3.2 0 v14 c0 5 -3 9 -8 9 -4 0 -6 -2 -8 -6 l-2 -5 c-1 -2 1 -4 2.8 -3 z" />
      <path d="M23 25 l3 -3 a1.6 1.6 0 0 1 2.3 2.2 l-3 3 z" />
    </>
  ),
};

export const ExecutionIcon = ({ type, size = 30, className = "", mirror = false }) => (
  <svg viewBox="0 0 40 48" width={size} height={size * 1.2} fill="currentColor" className={className} aria-hidden="true" focusable="false" style={mirror ? { transform: "scaleX(-1)" } : undefined}>
    {ICONS[type] || ICONS.gambaletto}
  </svg>
);

export const EXECUTION_ICON_TYPES = Object.keys(ICONS);
